import { MoveableBookFeature } from './moveable-book-feature';
import { environment } from '../../environments/environment';
import { Loggable } from './loggable';
import { Position } from './position';
import { TechnicalFeature } from '@lemberger/lemberger-am';

export class ReadspeakerElement extends MoveableBookFeature implements Loggable {

    enabled: boolean;
    texts: { original: string; current: string };
    button: Position;
    zIndex = 2;
    logType = TechnicalFeature.TextSelections;
    tool: null;
    changedPosition = false;

    getEndpointName(): string {
        return environment.endpointUrls.readspeakerElements;
    }

}
